import * as Sentry from '@sentry/react';
import current from '@config';

import { captureConsoleIntegration } from '@sentry/integrations';

export const initSentry = () => {
  Sentry.init({
    dsn: current.sentry.dsn,
    release: current.version,
    environment: current.sentry.environment,
    attachStacktrace: true,
    denyUrls: ['localhost'],
    integrations: [
      captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          'https://api.benefitsapi.com/graphql',
          'https://preview.getbenepass.com/proxy/graphql',
        ],
        networkRequestHeaders: [
          'x-benepass-workspace-id',
          'x-benepass-client',
          'x-benepass-version',
          'x-benepass-platform',
        ],
        networkCaptureBodies: false,
        networkResponseHeaders: ['x-benepass-request-id', 'apigw-requestid'],
        maskAllText: false,
        blockAllMedia: false,
        ignore: ['.ignore-me', '[data-replays-ignore]'],
        block: ['.block-me', '[data-replays-block]'],
        unblock: ['.unblock-me', '[data-replays-unblock]'],
        mask: ['.mask-me', '[data-replays-mask]'],
        unmask: ['.unmask-me', '[data-replays-unmask]'],
      }),
    ],
    ignoreErrors: [/ResizeObserver/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
  });
};
